import { motion } from "framer-motion";
import "../css/Hero.css";
// import { useNavigate } from "react-router-dom";
const Hero = () => {

    // const navigate = useNavigate();
    // const handleNavClickContactUs = (sectionId: string) => (e: React.MouseEvent) => {
    //     e.preventDefault();
    //     navigate(`/${sectionId}`);
    // };

    return (
        <section className="hero">
            <motion.div
                className="hero-content"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 30 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
                viewport={{ once: false, amount: 0.2 }} // Ensures animation triggers on scroll
            >
                {/* <motion.img
                    src="/assets/logo/logo.png"
                    alt="Sayon Logo"
                    className="logo"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{ duration: 1.2, ease: "easeOut", delay: 0.3 }}
                /> */}

                <motion.h1
                    className="hero-title"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 1.2, ease: "easeOut", delay: 0.5 }}
                    viewport={{ once: false, amount: 0.2 }}
                >
                    Sok Im Holding
                </motion.h1>
            </motion.div>

            {/* Contact button - separate animation */}
            <motion.button
                className="contact-btn"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 1, ease: "easeOut", delay: 0.8 }}
                whileHover={{ scale: 1.1 }}
                viewport={{ once: false, amount: 0.2 }}
                // onClick={handleNavClickContactUs("contact")}
            >
                Contact Us
            </motion.button>
        </section>
    );
};

export default Hero;